module.exports = __webpack_public_path__ + "static/media/29ADMSPC29.77d2ac9b.jpg";